import { render, staticRenderFns } from "./ApiMarketDetail.vue?vue&type=template&id=7337b7a8"
import script from "./ApiMarketDetail.vue?vue&type=script&lang=js"
export * from "./ApiMarketDetail.vue?vue&type=script&lang=js"
import style0 from "./ApiMarketDetail.vue?vue&type=style&index=0&id=7337b7a8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports